module.exports = __webpack_public_path__ + "static/media/movies.8882b509.png";